import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { TabContent } from '../../../shared/ui';

const getInitialTab = (tabs: TabContent[], currentLocationTabName: string) => {
  return tabs.find((tab) => tab.name === currentLocationTabName) || tabs[0];
};

export const useSelectedTab = (tabs: TabContent[]) => {
  const location = useLocation();
  const currentLocationTabName = location.pathname.split('/')[2];

  const [selectedTab, setSelectedTab] = useState(() =>
    getInitialTab(tabs, currentLocationTabName)
  );

  useEffect(() => {
    setSelectedTab(getInitialTab(tabs, currentLocationTabName));
  }, [currentLocationTabName, tabs]);

  return { selectedTab, setSelectedTab };
};
